import { format } from 'date-fns'

export default function dateFormatter(date) {
  if (date === null || date === undefined || date === '') {
    return ''
  }
  let dateArray = date?.split('-')
  if (dateArray.length === 3) {
    return format(
      new Date(dateArray[0], dateArray[1] - 1, dateArray[2]),
      'dd-MM-yyyy'
    )
  } else {
    return ''
  }
}
